export default __webpack_public_path__ + "static/media/auctionDetailLupa2.fb9ebccf.svg";